module.exports = __webpack_public_path__ + "img/icon.0484134b.png";